import styled, { css } from 'styled-components';

interface proposContentCam {
  errorPermissionCam?: any;
}

export const Container = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  height: 100vh; /* Use vh as a fallback for browsers that do not support Custom Properties */
  height: calc(var(--vh, 1vh) * 100);
  box-sizing: border-box;
  padding: 0 24px;
  background-color: var(--color-white-primary);
`;

export const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
`;

export const ContentSteps = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 100%;
  min-height: 100%;
  box-sizing: border-box;
  padding: 0 0 calc(98px + env(safe-area-inset-bottom, 0px)) 0;

  iframe {
    border: none;
    width: 100%;
    flex: 1;
    min-height: 0;
  }
  &.errorPermissionGeolocation {
    padding: 24px 0 35px;
    justify-content: flex-start;
  }
  &.terms {
    justify-content: center;
  }
`;

export const HeaderSteps = styled.div`
  display: flex;
  width: 100%;
  min-height: 56px;
  padding: 16px 36px;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-shrink: 0;

  button {
    background-color: inherit;
    border: none;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    padding: 0;
    display: flex;
    align-items: center;
  }
  h4 {
    margin: 0 !important;
    flex: 1;
    text-align: center;
  }
`;

export const TitleSteps = styled.h4`
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;

  color: var(--color-black-primary);
  margin: 30px 22px 38px;
  text-align: center;
`;

// List Proposal
export const ContentProposal = styled.div`
  flex-direction: column;
  width: 100%;
`;

export const ActionSignProposal = styled.div`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: var(--app-max-width, 100%);
  padding: 24px;
  padding-bottom: max(24px, env(safe-area-inset-bottom));
  background-color: var(--color-white-primary);
  z-index: 999;
  button {
    width: 100%;
  }
`;

export const LinkDownload = styled.div`
  margin-top: 24px;
  align-items: center;
  a {
    text-decoration: none;
    color: var(--color-blue-primary);
    font-size: 10px;
    margin-left: 12px;
  }
  svg {
    min-width: 16px;
  }
`;

// SCREEN SIGNSIGNATURE
export const ContainerSelfieTips = styled.div`
  padding: 24px 0;
  width: 100%;
  flex-direction: column;
  height: calc(100% - 91px);
  overflow-y: auto;
`;

export const TitleContentSelfieTips = styled.h4`
  font-weight: 600;
  font-size: 18px;
  line-height: 25px;
  color: var(--color-black-primary);
  margin-bottom: 30px;
`;

export const ContentSelfieTips = styled.div`
  background: #ffffff;
  border-radius: 10px;
  flex-direction: column;
  padding: 26px 32px;
  height: 100%;
`;
export const ItemSfieTips = styled.div`
  align-items: center;
  margin-bottom: 34px;
`;

export const IconsSelfieTipsIcons = styled.div`
  margin-right: 25px;
  margin-left: 8px;
`;
export const ParagraphSelfieTips = styled.div`
  font-size: 16px;
  line-height: 22px;
  color: var(--color-black-primary);
`;

// Selfie
export const ContainerSelfie = styled.div<proposContentCam>`
  flex-direction: column;
  width: 100%;
  height: 100%;
  flex: 1;
  background-color: var(--color-white-primary);
  justify-content: space-between;
  &.errorPermissionCam {
    background-color: inherit;
    padding: 24px 0 35px;
  }

  &.legacy-camera video {
    height: 100%;
  }
`;

//Sucess Selfie
export const ContainerSucess = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 100%;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;
export const LoadingContainerSucess = styled.div`
  width: 100%;
  flex: 1;
  justify-content: center;
  align-items: center;
`;

export const CotentSucess = styled.div`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 24px;
  gap: 16px;
  background-color: var(--color-black-primary);
`;

export const TitleSucess = styled.h4`
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
  text-align: center;
  color: var(--color-white-primary);
  margin: 0;
`;


// SCREEN SIGNSIGNATURE
export const ContainerSign = styled.div`
  padding: 24px 0;
  width: 100%;
  min-width: 100%;
`;
export const CotentSign = styled.div`
  flex-direction: column;
  width: 100%;
  background: var(--color-white-primary);
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  padding: 32px 32px calc(106px + env(safe-area-inset-bottom, 34px));
  text-align: center;
`;
export const TitleSign = styled.h4`
  font-size: 18px;
  line-height: 27px;
  margin-bottom: 24px;
  margin-top: 31px;
`;
export const TextSign = styled.p`
  font-size: 16px;
  line-height: 24px;
`;
export const DataLoan = styled.div`
  border-top: 1px solid #f5f6f7;
  padding-top: 32px;
  width: 100%;
  margin-top: 32px;
  justify-content: space-around;
`;
export const DataValueLoan = styled.div`
  font-size: 16px;
  line-height: 24px;
  flex-direction: column;
  align-items: center;
`;
export const ParagraphDataValueLoan = styled.p`
  font-size: 12px;
  line-height: 24px;
  color: #8e8e8e;
`;
export const SubParagraphDataValueLoan = styled.p`
  font-size: 14px;
  line-height: 21px;
  color: var(--color-black-primary);
`;

export const IconDataValueLoan = styled.div`
  background: #f5f6f7;
  border-radius: 6px;
  width: 40px;
  height: 40px;
  margin-bottom: 12px;
  align-items: center;
  justify-content: center;
`;

// ModalAction
export const ModalAction = styled.div`
  flex-direction: column;
  margin-top: 24px;
  width: 100%;
  > button:last-child {
    margin-left: 0px !important;
    margin-top: 8px;
    font-weight: 700;
  }
`;

// ---- Error Page
export const ErrorTitle = styled.h4`
  font-size: 18px;
  line-height: 30px;
  color: var(--color-black-primary);
  font-weight: 700;

  margin-bottom: 24px;
`;

// Retention Reason
export const ContentReason = styled.div`
  flex-direction: column;
  background-color: #fff;
  border-radius: 16px;
  padding: 24px;
  gap: 24px;
`;

export const TitleReason = styled.p`
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: #000;
`;
export const ErrorSubtitle = styled.p`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
  margin-top: -16px;
`;

export const Error = styled.div`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
`;

// Retention Finished
export const FinishedContainer = styled.div`
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const FinishedTitle = styled.p`
  font-size: 20px;
  line-height: 148%;
  color: #101010;
`;
export const FinishedText = styled.p`
  font-size: 16px;
  line-height: 24px;
  color: #4f4f4f;
`;
